import {Pipe, PipeTransform} from '@angular/core';
import _ from 'lodash';

@Pipe({
    name: 'overrideValues'
})
export class OverrideValuesPipe implements PipeTransform {

    transform(value: {}, overrideWith: {}, skipNullValues = true): any {

        if (skipNullValues) {
            for (var property in overrideWith) {
                if (!overrideWith[property]) {
                    delete overrideWith[property];
                }
            }
        }

        return {...value, ...overrideWith};
    }

}
